import useQueryParameters from './UseQueryParameters';
export default function useQueryParameter(key) {
    const params = useQueryParameters();
    if (params.has(key)) {
        return params.get(key) || '';
    }
    return undefined;
}
//# sourceMappingURL=UseQueryParameter.js.map